"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledTableHead = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../../framework/ty"));

var _templateObject;

var _default = {};
exports["default"] = _default;

var StyledTableHead = _styledComponents["default"].thead.withConfig({
  displayName: "TableHeadstyles__StyledTableHead",
  componentId: "sc-1o91j2u-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "])), function (_ref) {
  var _table$type$type;

  var table = _ref.theme.table,
      type = _ref.type;
  return "\n      ".concat((_table$type$type = table.type[type]) === null || _table$type$type === void 0 ? void 0 : _table$type$type.header, "\n    ");
}));

exports.StyledTableHead = StyledTableHead;